const shareData = {};
export default shareData;
